/*
 * @Author:
 * @LastEditTime: 2022-04-28 18:34:14
 * @Description:
 */
import Vue from 'vue'
import VueRouter from 'vue-router'

// fixed vue-router error @see https://blog.csdn.net/qq_34295211/article/details/102371714
const originPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onComplete, onAbort) {
  if (onComplete || onAbort) return originPush.call(this, location, onComplete, onAbort)
  return originPush.call(this, location).catch((err) => {
    return err
  })
}
/**
 * 这里专职创建router，不添加任何业务逻辑
 */
Vue.use(VueRouter)
const router = new VueRouter({
  mode: process.env.VUE_APP_DEBUG_MODE === 'qiankun' ? 'hash' : 'history',
  scrollBehavior: () => {
    return { y: 0 }
  },
  routes: [],
})

export default router
